import { Component } from '@angular/core';

/* eslint-disable @typescript-eslint/naming-convention */

@Component({
  selector: 'app-behaviour-code',
  templateUrl: './behaviour-code.page.html',
  styleUrls: ['./behaviour-code.page.scss']
})
export class BehaviourCodePage {
  readonly BEHAVIOUR_CODE_KEY = `conduct-code-pt-web`;
}
